import { default as addAddressV5w142buBoMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/addAddress.vue?macro=true";
import { default as advancedbooking8DQ4aCjB5DMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/advancedbooking.vue?macro=true";
import { default as advbookingcartFUPeBu41bqMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/advbookingcart.vue?macro=true";
import { default as advbookingconfkUC4UF7Xe1Meta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/advbookingconf.vue?macro=true";
import { default as advbookingmenuEzIPZlgFSPMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/advbookingmenu.vue?macro=true";
import { default as advbookingreqazl31sYWHRMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/advbookingreq.vue?macro=true";
import { default as advbookingsucAQZsvBjNG4Meta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/advbookingsuc.vue?macro=true";
import { default as chooseconfirm1VO5AQYQVBMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/chooseconfirm.vue?macro=true";
import { default as choosetableWP7NoRZoFGMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/choosetable.vue?macro=true";
import { default as confirmO67xUYdlRMMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/confirm.vue?macro=true";
import { default as deliveryAddressXjJ4A2cdCYMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/deliveryAddress.vue?macro=true";
import { default as editAddressX4qUeYaWJmMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/editAddress.vue?macro=true";
import { default as historybookingpnEJrNemn3Meta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/historybooking.vue?macro=true";
import { default as historyorderDSykxC4eclMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/historyorder.vue?macro=true";
import { default as indexPlK3ztUQgbMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/index.vue?macro=true";
import { default as mypageH3HSTriRrpMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/mypage.vue?macro=true";
import { default as mypagebookdetailsxMnmi9FtHJMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/mypagebookdetails.vue?macro=true";
import { default as aboutusThh5ZijdHkMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/aboutus.vue?macro=true";
import { default as bookcartHoGq2ee408Meta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/book/bookcart.vue?macro=true";
import { default as bookconf3YNexbahudMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/book/bookconf.vue?macro=true";
import { default as bookinfoC6R1aQp48ZMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/book/bookinfo.vue?macro=true";
import { default as bookmenuBRAMqB3wwsMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/book/bookmenu.vue?macro=true";
import { default as bookreqg3jABqZQnnMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/book/bookreq.vue?macro=true";
import { default as booksuczZ9amyhTswMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/book/booksuc.vue?macro=true";
import { default as bookz4fzWb1MUWMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/book.vue?macro=true";
import { default as bookingconfdIR3psnHHWMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booking/bookingconf.vue?macro=true";
import { default as bookingdateMXvQXVJ3gxMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booking/bookingdate.vue?macro=true";
import { default as bookinginfoR8yITU0Ph4Meta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booking/bookinginfo.vue?macro=true";
import { default as bookingmenuqfx1NuXGjSMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booking/bookingmenu.vue?macro=true";
import { default as bookingreqy6OCWN1wwwMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booking/bookingreq.vue?macro=true";
import { default as bookingsucx2xvcfGI1MMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booking/bookingsuc.vue?macro=true";
import { default as bookingKNVfuzOFxAMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booking.vue?macro=true";
import { default as booknowWnDD9NoQz3Meta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booknow.vue?macro=true";
import { default as gallery6WlscM5DrtMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/gallery.vue?macro=true";
import { default as homeSBBjBWnKhqMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/home.vue?macro=true";
import { default as menukYuW32yEBMMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/menu.vue?macro=true";
import { default as serviceh5ocDg4zT4Meta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/service.vue?macro=true";
import { default as voucherMJJVQ6ThDCMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/voucher.vue?macro=true";
import { default as vouchernows2032zrurYMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/vouchernow.vue?macro=true";
import { default as voucherPreviewesG9hdyL6XMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/voucherPreview.vue?macro=true";
import { default as navWPWxV99rIoMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav.vue?macro=true";
import { default as orderAddresskriRaPZaVCMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/orderAddress.vue?macro=true";
import { default as paymentB19AtDS7iCMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/payment.vue?macro=true";
import { default as paymentmethodsk2rJ5bzj6lMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/paymentmethods.vue?macro=true";
import { default as paymentorderrIJEJ7mmL6Meta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/paymentorder.vue?macro=true";
import { default as popupXfwZ3UEoKtMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/popup.vue?macro=true";
import { default as preferenceUAZwngE5uPMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/preference.vue?macro=true";
import { default as productPeyy7k2YwEMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/product.vue?macro=true";
import { default as sitemapSJEPHXtSBFMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/sitemap.vue?macro=true";
import { default as transferezTHIwZspLMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/transfer.vue?macro=true";
import { default as userinfo6LwHx9Ar8LMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/userinfo.vue?macro=true";
import { default as voucherconflztMM6ov3bMeta } from "/codebuild/output/src3681227186/src/ClientWebNuxt/pages/voucherconf.vue?macro=true";
export default [
  {
    name: "addAddress",
    path: "/addAddress",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/addAddress.vue")
  },
  {
    name: "advancedbooking",
    path: "/advancedbooking",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/advancedbooking.vue")
  },
  {
    name: "advbookingcart",
    path: "/advbookingcart",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/advbookingcart.vue")
  },
  {
    name: "advbookingconf",
    path: "/advbookingconf",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/advbookingconf.vue")
  },
  {
    name: "advbookingmenu",
    path: "/advbookingmenu",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/advbookingmenu.vue")
  },
  {
    name: "advbookingreq",
    path: "/advbookingreq",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/advbookingreq.vue")
  },
  {
    name: "advbookingsuc",
    path: "/advbookingsuc",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/advbookingsuc.vue")
  },
  {
    name: "chooseconfirm",
    path: "/chooseconfirm",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/chooseconfirm.vue")
  },
  {
    name: "choosetable",
    path: "/choosetable",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/choosetable.vue")
  },
  {
    name: "confirm",
    path: "/confirm",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/confirm.vue")
  },
  {
    name: "deliveryAddress",
    path: "/deliveryAddress",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/deliveryAddress.vue")
  },
  {
    name: "editAddress",
    path: "/editAddress",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/editAddress.vue")
  },
  {
    name: "historybooking",
    path: "/historybooking",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/historybooking.vue")
  },
  {
    name: "historyorder",
    path: "/historyorder",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/historyorder.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/mypage.vue")
  },
  {
    name: "mypagebookdetails",
    path: "/mypagebookdetails",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/mypagebookdetails.vue")
  },
  {
    name: "nav",
    path: "/nav",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav.vue"),
    children: [
  {
    name: "nav-aboutus",
    path: "aboutus",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/aboutus.vue")
  },
  {
    name: "nav-book",
    path: "book",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/book.vue"),
    children: [
  {
    name: "nav-book-bookcart",
    path: "bookcart",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/book/bookcart.vue")
  },
  {
    name: "nav-book-bookconf",
    path: "bookconf",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/book/bookconf.vue")
  },
  {
    name: "nav-book-bookinfo",
    path: "bookinfo",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/book/bookinfo.vue")
  },
  {
    name: "nav-book-bookmenu",
    path: "bookmenu",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/book/bookmenu.vue")
  },
  {
    name: "nav-book-bookreq",
    path: "bookreq",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/book/bookreq.vue")
  },
  {
    name: "nav-book-booksuc",
    path: "booksuc",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/book/booksuc.vue")
  }
]
  },
  {
    name: "nav-booking",
    path: "booking",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booking.vue"),
    children: [
  {
    name: "nav-booking-bookingconf",
    path: "bookingconf",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booking/bookingconf.vue")
  },
  {
    name: "nav-booking-bookingdate",
    path: "bookingdate",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booking/bookingdate.vue")
  },
  {
    name: "nav-booking-bookinginfo",
    path: "bookinginfo",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booking/bookinginfo.vue")
  },
  {
    name: "nav-booking-bookingmenu",
    path: "bookingmenu",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booking/bookingmenu.vue")
  },
  {
    name: "nav-booking-bookingreq",
    path: "bookingreq",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booking/bookingreq.vue")
  },
  {
    name: "nav-booking-bookingsuc",
    path: "bookingsuc",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booking/bookingsuc.vue")
  }
]
  },
  {
    name: "nav-booknow",
    path: "booknow",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/booknow.vue")
  },
  {
    name: "nav-gallery",
    path: "gallery",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/gallery.vue")
  },
  {
    name: "nav-home",
    path: "home",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/home.vue")
  },
  {
    name: "nav-menu",
    path: "menu",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/menu.vue")
  },
  {
    name: "nav-service",
    path: "service",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/service.vue")
  },
  {
    name: "nav-voucher",
    path: "voucher",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/voucher.vue")
  },
  {
    name: "nav-vouchernow",
    path: "vouchernow",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/vouchernow.vue")
  },
  {
    name: "nav-voucherPreview",
    path: "voucherPreview",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/nav/voucherPreview.vue")
  }
]
  },
  {
    name: "orderAddress",
    path: "/orderAddress",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/orderAddress.vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/payment.vue")
  },
  {
    name: "paymentmethods",
    path: "/paymentmethods",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/paymentmethods.vue")
  },
  {
    name: "paymentorder",
    path: "/paymentorder",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/paymentorder.vue")
  },
  {
    name: "popup",
    path: "/popup",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/popup.vue")
  },
  {
    name: "preference",
    path: "/preference",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/preference.vue")
  },
  {
    name: "product",
    path: "/product",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/product.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/sitemap.vue")
  },
  {
    name: "transfer",
    path: "/transfer",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/transfer.vue")
  },
  {
    name: "userinfo",
    path: "/userinfo",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/userinfo.vue")
  },
  {
    name: "voucherconf",
    path: "/voucherconf",
    component: () => import("/codebuild/output/src3681227186/src/ClientWebNuxt/pages/voucherconf.vue")
  }
]